var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChannelThreads14 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  viewBox: "0 0 14 14",
  role: "img"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 14,
  height: 14,
  fill: "#FF3CA0",
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "m9.225 6.635-.122-.06C9.031 5.153 8.31 4.34 7.095 4.33H7.08c-.726 0-1.33.334-1.7.94l.666.492c.278-.453.713-.55 1.034-.55h.011q.602.006.896.372.213.267.284.732a4.8 4.8 0 0 0-1.146-.06c-1.154.072-1.896.795-1.846 1.8.025.51.262.95.665 1.236.342.243.781.361 1.238.334.603-.035 1.077-.283 1.407-.736.25-.343.41-.789.48-1.35.287.187.5.432.618.727.2.502.212 1.327-.414 1.999-.548.589-1.207.844-2.203.852-1.105-.01-1.94-.39-2.483-1.133-.51-.695-.772-1.7-.782-2.985.01-1.286.273-2.29.782-2.985.543-.743 1.378-1.124 2.483-1.133 1.113.01 1.963.392 2.527 1.138.276.366.485.826.622 1.363L11 5.158c-.167-.66-.429-1.23-.785-1.701C9.49 2.5 8.434 2.01 7.072 2h-.006c-1.36.01-2.405.502-3.108 1.462-.625.855-.947 2.044-.958 3.534v.008c.01 1.49.333 2.679.958 3.534.703.96 1.748 1.452 3.108 1.462h.006c1.208-.009 2.06-.35 2.762-1.104.919-.986.891-2.223.589-2.982-.218-.545-.632-.987-1.198-1.28m-2.087 2.11c-.506.03-1.03-.213-1.057-.736-.019-.388.257-.82 1.088-.872q.143-.009.28-.008.455 0 .842.091c-.096 1.287-.658 1.496-1.153 1.525"
}))));
export default SvgChannelThreads14;